(function(){
/* Zumm Health — About page */
const {
  motion
} = window.Motion;
const {
  Nav,
  Footer,
  TopBar,
  Microbes,
  Reveal,
  fadeUp,
  stagger
} = window.Z;
function AboutPage() {
  const values = [{
    ico: '🚫',
    bg: 'rgba(228,69,58,.16)',
    title: 'No sugar, ever',
    text: 'If a supplement needs sugar to get taken, we redesign the supplement — not the standard. Every Zumm product is sugar‑free.'
  }, {
    ico: '🔬',
    bg: 'rgba(94,139,196,.18)',
    title: 'Proof over promises',
    text: 'GMP‑certified manufacturing and third‑party testing on every batch. What the label says is what’s in the bottle.'
  }, {
    ico: '🥼',
    bg: 'rgba(45,155,111,.18)',
    title: 'Doctor‑built formulas',
    text: 'Each formula starts with a board‑certified pediatric gastroenterologist and 15 years of clinical experience — not a marketing brief.'
  }, {
    ico: '❤️',
    bg: 'rgba(255,140,66,.18)',
    title: 'Made for real families',
    text: 'Twist‑open capsules, chewables kids don’t fight, and honest labels parents can actually read. Health that fits real life.'
  }];
  const timeline = [{
    t: 'The waiting‑room question',
    d: 'After years of hearing the same worry — "which kids’ vitamin actually works?" — a pediatric gut specialist got tired of pointing parents toward sugary gummies with barely any active ingredient.'
  }, {
    t: 'A different formula',
    d: 'The idea: build supplements the way a gut doctor would — real strains, real doses, delayed‑release delivery, and absolutely no sugar. Zumm Health was born to do exactly that.'
  }, {
    t: 'Tested, then trusted',
    d: 'Every formula went into a GMP‑certified facility with third‑party testing, so families never have to take potency on faith.'
  }, {
    t: 'The whole system',
    d: 'Today Zumm spans a 60 billion CFU adult probiotic, a kids’ 24 billion probiotic, a sugar‑free multivitamin, and a kids’ book that explains it all — one connected approach to everyday wellness.'
  }];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TopBar, null), /*#__PURE__*/React.createElement(Nav, {
    current: "about.html"
  }), /*#__PURE__*/React.createElement("header", {
    className: "pp-hero",
    style: {
      '--pp-glow': 'rgba(45,155,111,.4)'
    }
  }, /*#__PURE__*/React.createElement(Microbes, {
    count: 12
  }), /*#__PURE__*/React.createElement("div", {
    className: "wrap",
    style: {
      textAlign: 'center',
      maxWidth: 900,
      margin: '0 auto'
    }
  }, /*#__PURE__*/React.createElement(motion.div, {
    initial: "hidden",
    animate: "visible",
    variants: stagger
  }, /*#__PURE__*/React.createElement(motion.span, {
    className: "eyebrow green",
    variants: fadeUp
  }, "Our Story"), /*#__PURE__*/React.createElement(motion.h1, {
    className: "h-xl",
    variants: fadeUp,
    style: {
      margin: '22px 0 20px'
    }
  }, "We got tired of", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
    className: "accent-green"
  }, "candy in a vitamin bottle.")), /*#__PURE__*/React.createElement(motion.p, {
    className: "lead",
    variants: fadeUp,
    style: {
      margin: '0 auto'
    }
  }, "Zumm Health makes clean, pediatrician‑formulated supplements that put the science first and the sugar nowhere. No gummies. No sugar. No nonsense — that's the whole promise, printed right on every label.")))), /*#__PURE__*/React.createElement("section", {
    className: "section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrap"
  }, /*#__PURE__*/React.createElement(Reveal, null, /*#__PURE__*/React.createElement("span", {
    className: "eyebrow orange"
  }, "What We Stand For")), /*#__PURE__*/React.createElement(Reveal, null, /*#__PURE__*/React.createElement("h2", {
    className: "h-lg",
    style: {
      margin: '18px 0 46px'
    }
  }, "Four rules we ", /*#__PURE__*/React.createElement("span", {
    className: "accent-orange"
  }, "won't break"))), /*#__PURE__*/React.createElement(Reveal, {
    className: "benefit-list",
    variants: stagger,
    amount: .15
  }, values.map(v => /*#__PURE__*/React.createElement(motion.div, {
    className: "benefit",
    key: v.title,
    variants: fadeUp,
    whileHover: {
      y: -6
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "bico",
    style: {
      background: v.bg
    }
  }, v.ico), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", null, v.title), /*#__PURE__*/React.createElement("p", null, v.text))))))), /*#__PURE__*/React.createElement("section", {
    className: "section",
    style: {
      paddingTop: 20
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrap"
  }, /*#__PURE__*/React.createElement(Reveal, null, /*#__PURE__*/React.createElement("span", {
    className: "eyebrow"
  }, "How We Got Here")), /*#__PURE__*/React.createElement(Reveal, null, /*#__PURE__*/React.createElement("h2", {
    className: "h-lg",
    style: {
      margin: '18px 0 50px'
    }
  }, "From the exam room ", /*#__PURE__*/React.createElement("span", {
    className: "accent-blue"
  }, "to your kitchen counter"))), /*#__PURE__*/React.createElement("div", {
    className: "timeline"
  }, timeline.map((s, i) => /*#__PURE__*/React.createElement(Reveal, {
    className: "tl-item",
    key: s.t,
    amount: .4
  }, /*#__PURE__*/React.createElement("h4", null, s.t), /*#__PURE__*/React.createElement("p", null, s.d)))))), /*#__PURE__*/React.createElement("section", {
    className: "section",
    style: {
      paddingTop: 10
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrap"
  }, /*#__PURE__*/React.createElement(Reveal, {
    className: "quoteband",
    amount: .4
  }, /*#__PURE__*/React.createElement("span", {
    className: "eyebrow green"
  }, "The People Behind Zumm"), /*#__PURE__*/React.createElement("h2", {
    className: "h-md",
    style: {
      marginTop: 18
    }
  }, "Formulated by a board‑certified pediatric gastroenterologist with a PhD in microbiology and 15 years of clinical practice."), /*#__PURE__*/React.createElement("p", {
    style: {
      color: 'var(--text-dim)',
      marginTop: 16,
      maxWidth: 620,
      marginInline: 'auto'
    }
  }, "Our formulas are guided by clinicians who spend their days helping kids' guts work better — and who wanted a supplement line they'd feel good handing to their own patients.")))), /*#__PURE__*/React.createElement("section", {
    className: "section",
    style: {
      paddingTop: 10,
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrap"
  }, /*#__PURE__*/React.createElement(Reveal, null, /*#__PURE__*/React.createElement("h2", {
    className: "h-lg",
    style: {
      marginBottom: 20
    }
  }, "Be your best.")), /*#__PURE__*/React.createElement(Reveal, null, /*#__PURE__*/React.createElement("p", {
    className: "lead",
    style: {
      margin: '0 auto 30px'
    }
  }, "Meet the full Zumm system — clean formulas for the whole family.")), /*#__PURE__*/React.createElement(Reveal, null, /*#__PURE__*/React.createElement(motion.a, {
    className: "btn btn-orange",
    href: "index.html#shop",
    whileHover: {
      scale: 1.05
    },
    whileTap: {
      scale: .95
    }
  }, "Explore the Products →")))), /*#__PURE__*/React.createElement(Footer, null));
}
ReactDOM.createRoot(document.getElementById('root')).render(/*#__PURE__*/React.createElement(AboutPage, null));})();
